export default __webpack_public_path__ + "static/media/online_banking.c3cd03e7.svg";